export * from './agris-cliente-cotizacion-card.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-cliente-cotizacion-card/index.ts